import { InputWithOptionsUniDriver } from '../InputWithOptions/InputWithOptions.uni.driver';

export { inputWithOptionsUniDriverFactory as autoCompleteUniDriverFactory } from '../InputWithOptions/InputWithOptions.uni.driver';

export type AutoCompleteUniDriver = InputWithOptionsUniDriver;
